import { Tenant } from "@/types/tenant";
import { TenantCard } from "./TenantCard";

interface TenantGridProps {
  tenants: Tenant[];
  hasPendingDeletion: (tenantId: string) => boolean;
  onRequestDeletion: (tenantId: string) => void;
}

export const TenantGrid = ({ tenants, hasPendingDeletion, onRequestDeletion }: TenantGridProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {tenants.map((tenant) => (
        <TenantCard
          key={tenant.id}
          tenant={tenant}
          hasPendingDeletion={hasPendingDeletion(tenant.id)}
          onRequestDeletion={onRequestDeletion}
        />
      ))}
    </div>
  );
};
